import { createFileRoute } from '@tanstack/react-router';
import { useAdminAuthGuard } from '@/features/admin/hooks';
import { ArchiveImportRunsPanel } from '@/features/admin/ArchiveImportRunsPanel';
import { AdminShell } from '@/features/admin/components/AdminShell';
import { AdminPageHeader } from '@/features/admin/components/AdminPageHeader';
import { AdminLogoutButton } from '@/features/admin/components/AdminLogoutButton';

/**
 * Admin Archive Import Runs route — platform operator's view of every in-flight (pending/importing)
 * archive-unzip job plus recent failures, with Kill / Retry, the imports-per-worker dial, and the
 * DLQ depth. Bounces to /admin/login if the admin cookie isn't set.
 */
export const Route = createFileRoute('/admin/archive-import-runs')({
  component: AdminArchiveImportRunsPage,
});

function AdminArchiveImportRunsPage() {
  useAdminAuthGuard();
  return (
    <AdminShell actions={<AdminLogoutButton />}>
      <AdminPageHeader
        title="Archive Import Runs"
        subtitle="Every vault archive-unzip job currently pending or importing, across all companies, plus recent failures. Stale jobs (a worker likely died) are highlighted. Kill a wedged import to fail it now, or Retry a failed one for a fresh attempt."
      />
      <ArchiveImportRunsPanel />
    </AdminShell>
  );
}
